import { Component, Input, OnInit } from "@angular/core";
import { DataService_MultiStationViewVisitors } from "../shared/data.service";

@Component({
	selector: "caass-ms-visitor-offender-lookup-history",
	templateUrl: "./ms-visitor-offender-lookup-history.component.html",
	styleUrls: ["./ms-visitor-offender-lookup-history.component.css"],
})
export class MsVisitorOffenderLookupHistoryComponent implements OnInit {
	constructor(private visitorService: DataService_MultiStationViewVisitors) {}

	//INSERT ON INIT HERE
	ngOnInit(): void {
		this.loadOffenderSearchLog();
	}

	ngOnChanges() {
		this.loadOffenderSearchLog();
	}

	////////////////////////////////////////////
	// Data
	////////////////////////////////////////////

	@Input() SelectedVisitor: any;

	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;

	SelectedOffenderSearchLog: any;
	lstOffenderSearchLog: any = [];

	////////////////////////////////////////////

	////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////

	loadOffenderSearchLog() {
		this.lstOffenderSearchLog = [];
		this.SelectedOffenderSearchLog = null;

		if (this.SelectedVisitor == undefined || this.SelectedVisitor.PersonID == undefined) {
			return;
		}

		var result = this.visitorService.VisitorOffenderLookupHistorySelectList(this.SelectedVisitor.PersonID);
		result.subscribe(
			(response) => {
				this.lstOffenderSearchLog = response;
			},
			(error) => {}
		);
	}

	////////////////////////////////////////////
}
